import { render } from "./RulesSetsTable.vue?vue&type=template&id=29c8c6f6"
import script from "./RulesSetsTable.vue?vue&type=script&lang=js"
export * from "./RulesSetsTable.vue?vue&type=script&lang=js"

import "./RulesSetsTable.vue?vue&type=style&index=0&id=29c8c6f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__